
export interface IDonorConnectMentorPerformanceMonth {
    monthYear: string,
    contactsAssigned: number,
    contactsAttempted: number,
    contactsMade: number,
    disconnectsMade: number,
    surveysCompleted: number,
    surveryCompletedType: ISurveryCompletedType,
    donations: number,
    responseRateCurrentMonth: number,
    contactsCompletionRateCurrentMonth: number,
    surveysCompletionRateCurrentMonth: number,
    donationRateCurrentMonth: number,
    disconnectRateCurrentMonth: number
}

export interface ISurveryCompletedType {
    workUpCompleted: number,
    preOpCompleted: number,
    atSurgeryCompleted: number,
    postSurgeryCompleted: number
}